import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <div class="materials-wrapper">
            <ng-transclude></ng-transclude>
        </div>
        <style>
            learn-modal-materials-wrapper {
                display: contents;
            }

            .materials-wrapper {
                display: flex;
            }
        </style>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/materialsWrapper/index.js